import { DataCard } from '../../../components/DashboardCard';
import { useTopDetailPages } from '../../../hooks/Dashboard/useTopDetailPages';

export const TopDetailPagesCard = (props: DashboardCardProps) => {
  const { theme } = props;
  const { topDetailPages, getTopDetailPages, loading } = useTopDetailPages();

  return (
    <DataCard
      data={topDetailPages}
      title="Top Detail Pages"
      views={['list', 'graph', 'pie']}
      columns={[
        { name: 'Page Name', dataKey: 'id' },
        { name: 'Hits', dataKey: 'value', isNumeric: true },
      ]}
      bottomLabel="Page Name"
      leftLabel="Hits"
      refresh={true}
      loading={loading}
      onRefresh={getTopDetailPages}
      enableTimespan
      theme={theme}
    />
  );
};
